import React from 'react'
import cx from 'classnames'
import styles from './Scale.module.scss'

type ScaleScore = { score: number; id: string | number }

type ScaleProps = {
  scores: ScaleScore[]
  single?: boolean
  selectedCandidates?: Record<string, boolean>
  withHighlight?: boolean
}

export const Scale = ({
  scores,
  single,
  selectedCandidates = {},
  withHighlight = true,
}: ScaleProps) => {
  const scoresIdentical =
    !single &&
    scores[0].score === scores[1].score &&
    selectedCandidates[scores[0].id] &&
    selectedCandidates[scores[1].id]

  return (
    <div className={styles.scale}>
      {scores.map(({ score, id }, index) => {
        if (isNaN(score)) {
          return null
        }

        return (
          <div
            className={cx(styles.circle, {
              [styles.highlight]: withHighlight && (score < 35 || score > 66),
              [styles.hidden]: !single && !selectedCandidates[id],
              [styles.second]: !single && index,
              [styles.first]: !single && !index,
              [styles.scoresIdentical]: scoresIdentical,
            })}
            key={id}
            style={{ left: `calc(${score}% - 0.9rem)` }}
          >
            {score}
          </div>
        )
      })}

      {[...Array(14).keys()].map(key => (
        <div
          key={key}
          className={cx(styles.step, {
            [styles.extremeLeft]: [0].includes(key),
            [styles.extremeRight]: [13].includes(key),
            [styles.middle]: [5, 6, 7, 8].includes(key),
          })}
        ></div>
      ))}
    </div>
  )
}
